<template>
    <div v-if="data">
        <h3>{{data.label}}</h3>
        <div v-for="(element, index) in data.formElements" :key="index">
            <p v-if="element.type !== 'header'" class="no-margin">{{element.label}}</p>
            <component :is="'kollecto-' + element.type" :userAction="userAction" :formElement="element" class="form-element"></component>
        </div>
    </div>
</template>

<script>
// forms
import textarea from "./../standard/textarea";
import radiobutton from "./../standard/radiobutton";
import checkbox from "./../standard/checkbox";
import select from "./../standard/select";
import hidden from "./../standard/hidden";
import image from "./../standard/image";
import date from "./../standard/textbox-date";
import number from "./../standard/textbox-number";
import text from "./../standard/text";
import toggle from "./../standard/toggle";
import header from "./../standard/header";

export default {
  name: "repeater-modal",
  props: ["data", "userAction"],
  components: {
    "kollecto-textarea": textarea,
    "kollecto-radiobutton": radiobutton,
    "kollecto-checkbox": checkbox,
    "kollecto-select": select,
    "kollecto-hidden": hidden, // missing
    "kollecto-image": image,
    "kollecto-date": date,
    "kollecto-number": number,
    "kollecto-text": text,
    "kollecto-toggle": toggle,
    "kollecto-header": header
  },
  methods: {
    closeModal() {
      this.$emit("close");
    }
  }
};
</script>
